import type { FactoryEdit } from '@indutrust/factory-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Workflow events for the factory approval pipeline.
 *
 * Drives two distinct actions:
 *
 * - `submitForApproval*` → `PATCH /factories/{id}/submit_for_approval`
 *   (supplier asks admin to review)
 * - `publish*` → `PATCH /factories/{id}/publish`
 *   (admin makes the factory visible)
 *
 * Pattern B (custom workflow) — not a CRUD.
 */
export const factoryApprovalEvents = eventGroup({
  source: 'factory.approval',
  events: {
    submitForApprovalRequested: type<{ factoryId: number }>(),
    submitForApprovalSucceeded: type<{ factory: FactoryEdit }>(),
    submitForApprovalFailed: type<{ error: string }>(),

    publishRequested: type<{ factoryId: number }>(),
    publishSucceeded: type<{ factory: FactoryEdit }>(),
    publishFailed: type<{ error: string }>(),
  },
});
